/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import { LinearProgress, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import CachingController from './CachingController';
import ConnectionStatus from './common/components/ConnectionStatus';
import { useTranslation } from './common/components/LocalizationProvider';
import theme from './common/theme';
import AdBanner from './main/components/BannerAds';

import PasswordPrompt from './other/PasswordPromt';
import { useEffectAsync } from './reactHelper';
import SocketController from './SocketControllerNoAuth';

const useStyles = makeStyles(() => ({
  page: {
    flexGrow: 1,
    overflow: 'auto',
  },
  menu: {
    zIndex: 4,
  },
}));

const ShareNoAuth = () => {
  const classes = useStyles();
  const desktop = useMediaQuery(theme.breakpoints.up('sm'));
  const [initialized, setInitialized] = useState(false);
  const navigate = useNavigate();
  const t = useTranslation();

  const [code, setCode] = useState(null);
  const [obj, setObj] = useState(null);
  const [requiresPassword, setRequiresPassword] = useState(false);
  const [promptError, setPromptError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const verifyCode = async (_code) => {
    setCode(_code);

    const r = await fetch('/api/links/verify', {
      method: 'POST',
      body: JSON.stringify({ code: _code }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (r.ok) {
      const data = await r.json();
      setObj(data);

      if (data.requiresPassword) {
        setRequiresPassword(true);
      } else {
        setInitialized(true);
      }
    } else {
      window.Notiflix.Report.failure(
        'Notiflix Success',
        'Enlace invalido',
        'Okay',
      );
    }
  };

  const handlePasswordSubmit = async (value) => {
    setSubmitting(true);
    setPromptError('');

    try {
      const r = await fetch('/api/links/authenticate', {
        method: 'POST',
        body: JSON.stringify({ code, pass: value }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (r.ok) {
        setInitialized(true);
      } else if (r.status === 401) {
        setPromptError(t('password_wrong'));
      } else {
        setPromptError('Enlace invalido');
      }
    } catch (error) {
      setPromptError('Error de conexión, intenta de nuevo');
    } finally {
      setSubmitting(false);
    }
  };

  useEffectAsync(async () => {
    if (!initialized) {
      const urlParams = new URLSearchParams(window.location.search);
      if (!urlParams.get('code')) {
        window.alertify.alert('Error', 'Link invalido', () => { navigate('/login'); });
      } else {
        await verifyCode(urlParams.get('code'));
      }
    }
    return null;
  }, []);

  return !initialized ? (
    <>
      <LinearProgress />
      {requiresPassword && (
        <PasswordPrompt
          open={requiresPassword && !initialized}
          onSubmit={handlePasswordSubmit}
          error={promptError}
          loading={submitting}
        />
      )}
    </>
  ) : (
    <>
      <ConnectionStatus />
      <SocketController />
      <CachingController />
      <div className={classes.page}>
        <Outlet />
      </div>
      <AdBanner>
        <p className="ad-banner-text">
          CONTRATA NUESTRO SERVICIO DE RASTREO AL
          {' '}
          <span>
            <a href="tel:4434521162">4434521162</a>
          </span>
        </p>
        <a href="https://www.gpstracker.mx">
          <button type="button" className="ad-banner-cta">GPS TRACKER MX &#8594;</button>
        </a>
      </AdBanner>
      <AdBanner
        align="top"
        width={desktop ? '97%' : '85%'}
        delay={5}
        animationName="ad-banner-dropBanner"
      >
        <p className="ad-banner-text">
          ESTE ENLACE EXPIRA EL:
          {' '}
          {(new Date(obj?.limitDate || new Date())).toLocaleDateString()}
        </p>
      </AdBanner>
    </>
  );
};

export default ShareNoAuth;